import * as websocket from "../util/websocket.ts";
import * as amplify from "../util/amplify.ts";
import ApiServer from "../ApiServer.ts";
import * as Html from "../util/Html.ts";
import * as modal from "../util/modal.ts";
export {initDom,destroyDom}
Html.registerWidget('widget/map-notificationhandler',{initDom,destroyDom})

var askingLocationModal;


Html.registerDom({
  "requestlocation":ApiServer.locrequestpositionrefresh.prepare(async function(hasSent){
    modal.closeDomModal()
    if(websocket.isActive){
      askingLocationModal = await modal.alertModal('map.locationRefreshSentWithNotif');
    }else{
      askingLocationModal = await modal.alertModal('map.locationRefreshSent');
    }
  }),
  "requestautotrack":ApiServer.locrequestautotrack.prepare(async function(hasSent){
    modal.closeDomModal()
    askingLocationModal = await modal.alertModal('map.locationRequestAutotrackSent');
  })
});



function refresh(webPushMessage){
  modal.closeDomModal(askingLocationModal);

  const locationElement = document.querySelector("[data-fw-location-accountid]");
  const watchingUserId = locationElement?.getAttribute("data-fw-location-accountid");
  if(watchingUserId===webPushMessage.push.targetId){
    amplify.publish('familyMemberSelected',{selected:watchingUserId});
  }else{
    const refreshButton = document.querySelector("[data-fw-onclick='maprefresh']") as HTMLElement;
    if(refreshButton) refreshButton.click();
  }
}
/*
 * for debugging use
 * emulateNotification({type:"push",push:{messageType:"GeolocPositionRefreshResponse",targetId:29766}})
 *
 */
function initDom(obj: HTMLElement){
  websocket.subscribe(["GeolocAutotrackAccepted","GeolocPositionRefreshResponse","New_Checkin"],refresh);
}
function destroyDom(obj: HTMLElement){
  websocket.unsubscribe(["GeolocAutotrackAccepted","GeolocPositionRefreshResponse","New_Checkin"],refresh);
}